import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import * as moment from 'moment';

@Component({
	selector: 'app-new-action-items',
	templateUrl: './new-action-items.component.html',
	styleUrls: ['./new-action-items.component.scss']
})
export class NewActionItemsComponent implements OnInit {
	APP_CONSTANTS = APP_CONSTANTS;

	user_details: any;
	user_role: any;

	type: any = "";
	tab: any = "";

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
		private router: Router,
		private route: ActivatedRoute,
		private datePipe: DatePipe
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 3) {
			this.user_role = "Executive";
		} else if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Leadership";
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
		}

		this.route.params.subscribe((params) => {
			this.type = params['type'];
			this.tab = params['tab'];
		});

		this.getActionItemsDataSummary();

		// this.getTopActionItems();

		this.getActionItemsData();

		// this.searchSubject.pipe(

		// 	debounceTime(400),

		// 	distinctUntilChanged(),

		// 	switchMap(search: any => {
		// 		return this.getActionItemsData(search);
		// 	})

		// ).subscribe(response => {

		// 	this.action_items_data = response;

		// });


	}

	page_data: any;
	page_data_loaded: boolean = false;
	getActionItemsDataSummary() {
		this.page_data_loaded = false;
		let route: any = "/";

		if (this.user_details.role.role == 3) {
			route = "/executiveactionitemsummary/";
		} else if (this.user_details.role.role == 4) {
			route = "/advisormanageractionitemsummary/";
		} else if (this.user_details.role.role == 5) {
			route = "/advisoractionitemsummary/";
		} else if (this.user_details.role.role == 6) {
			route = "/afaactionitemsummary/";
		} else if (this.user_details.role.role == 7) {
			route = "/assistantactionitemsummary/";
		} else if (this.user_details.role.role == 8) {
			route = "/rmactionitemsummary/";
		} else if (this.user_details.role.role == 10) {
			route = "/leadershipactionitemsummary/";
		} else if (this.user_details.role.role == 11) {
			route = "/drmactionitemsummary/";
		} else if (this.user_details.role.role == 12) {
			route = "/wholesaleractionitemsummary/";
		} else if (this.user_details.role.role == 13) {
			route = "/lendingactionitemsummary/";
		} else if (this.user_details.role.role == 14) {
			route = "/insuranceactionitemsummary";
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_data = res['data'];
				this.page_data_loaded = true;

			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	top_action_data: any = [];
	getTopActionItems() {
		let route: any = "/";

		if (this.user_details.role.role == 3) {
			route = "/executiveactionitemactivity/";
		} else if (this.user_details.role.role == 4) {
			route = "/advisormanageractionitemactivity/";
		} else if (this.user_details.role.role == 5) {
			route = "/advisoractionitemactivity/";
		} else if (this.user_details.role.role == 6) {
			route = "/afaactionitemactivity/";
		} else if (this.user_details.role.role == 7) {
			route = "/assistantactionitemactivity/";
		} else if (this.user_details.role.role == 8) {
			route = "/rmactionitemactivity/";
		} else if (this.user_details.role.role == 10) {
			route = "/leadershipactionitemsummary/";
		} else if (this.user_details.role.role == 11) {
			route = "/drmactionitemactivity/";
		} else if (this.user_details.role.role == 12) {
			route = "/wholesaleractionitemsummary/";
		} else if (this.user_details.role.role == 13) {
			route = "/lendingactionitemsummary/";
		} else if (this.user_details.role.role == 14) {
			route = "/insuranceactionitemsummary/";
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.top_action_data = res['data'];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}



	action_items_data: any;
	action_items_data_loaded: boolean = false;
	getActionItemsData() {
		this.action_items_data_loaded = false;
		let route: any = "/";

		if (this.user_details.role.role == 3) {
			route = "/executiveactionitems";
		} else if (this.user_details.role.role == 4) {
			route = "/advisormanageractionitems";
		} else if (this.user_details.role.role == 5) {
			route = "/advisoractionitems";
		} else if (this.user_details.role.role == 6) {
			route = "/afaactionitems";
		} else if (this.user_details.role.role == 7) {
			route = "/assistantactionitems";
		} else if (this.user_details.role.role == 8) {
			route = "/rmactionitems";
		} else if (this.user_details.role.role == 10) {
			route = "/leadershipactionitemsummary";
		} else if (this.user_details.role.role == 11) {
			route = "/drmactionitems";
		} else if (this.user_details.role.role == 12) {
			route = "/wholesaleractionitemsummary";
		} else if (this.user_details.role.role == 13) {
			route = "/lendingactionitemsummary";
		} else if (this.user_details.role.role == 14) {
			route = "/insuranceactionitemsummary";
		}

		if (this.action_items_duration == "Schedule") {
			route = route + "?duration=" + this.action_items_duration;
			route = route + "&start_date=" + this.datePipe.transform(this.action_items_date[0], 'yyyy-MM-dd');
			route = route + "&end_date=" + this.datePipe.transform(this.action_items_date[1], 'yyyy-MM-dd');
		} else {
			route = route + "?duration=" + this.action_items_duration;
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.action_items_data = res['data'];
				this.action_items_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	// action_items_duration: any = "All";
	action_items_duration: any = "Today";
	action_items_date: any = "";
	segregateActionItemsDuration(value) {
		this.action_items_duration = value;
		if (this.action_items_duration != "Schedule") {
			this.action_items_date = "";
			this.getActionItemsData();
		}
	}

	onDateRangeChange(data) {
		this.action_items_date = data;
		this.getActionItemsData();
	}

	topTaskAction(activity) {
		if (activity.action_type == 'Email') {
			const mailtoLink = `mailto:${activity.action_value}`;
			window.open(mailtoLink, '_blank');
		} else if (activity.action_type == 'Phone') {
			const telLink = `tel:${activity.action_value}`;
			window.open(telLink, '_blank');
		} else {
			this.viewIndividualActivity(activity);
			// window.open(activity.action_value, '_blank');
		}
	}

	markDone(activity) {
		const payload = {
			id: activity.id,
			type: activity.type,
		};
		this.commonService.postData("/updatetaskstatus/", payload).subscribe(
			(res: any) => {
				// this.getTopActionItems();
				this.getActionItemsData();
				this.commonService.showToast('success', "Activity Updated Successfully");
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	viewIndividualActivity(activity) {
		let role: any = "";
		if (this.user_details.role.role == 3) {
			role = '/executive';
		} else if (this.user_details.role.role == 4) {
			role = '/advisor-manager';
		} else if (this.user_details.role.role == 5) {
			role = '/advisor';
		} else if (this.user_details.role.role == 6) {
			role = '/afa';
		} else if (this.user_details.role.role == 7) {
			role = '/assistant';
		} else if (this.user_details.role.role == 8) {
			role = '/relationship-manager';
		} else if (this.user_details.role.role == 10) {
			role = '/leadership';
		} else if (this.user_details.role.role == 11) {
			// role = '/marketing-team';
			role = '/opportunity';
		} else if (this.user_details.role.role == 12) {
			role = '/wholesaler';
		} else if (this.user_details.role.role == 13) {
			role = '/lending-officer';
		} else if (this.user_details.role.role == 14) {
			role = '/insurance-agent';
		}

		this.router.navigate([role + '/activity-details/' + activity.activity_type + "/" + activity.id], { state: { previousRoute: this.router.url } });

	}

	navigateToAIGovernance() {
		this.router.navigate(['/advisor/ai-governance/summary']);
	}

	viewTaskDetails(data) {
		if (data.type == 'engagement') {
			this.openGroupedActivity(data);
		} else {
			this.viewIndividualActivity(data);
		}
	}

	show_grouped_action_item: boolean = false;
	show_grouped_action_item_meta_data: any;
	openGroupedActivity(data) {
		this.show_grouped_action_item_meta_data = JSON.parse(JSON.stringify(data));
		this.show_grouped_action_item = true;
		this.getGroupedActionItemData();
	}

	closeGroupedActivity() {
		this.show_grouped_action_item = false;
		this.show_grouped_action_item_meta_data = {};

		this.getActionItemsDataSummary();

		// this.getTopActionItems();

		this.getActionItemsData();

		this.email_data = {
			subject: "",
			email_body: "",
			scheduled_date: "",
		};
		this.email_data_errors = {
			subject: false,
			email_body: false,
			scheduled_date: false,
		};
		this.show_email_input_section = false;

	}


	grouped_action_item_segement: any = "all";

	grouped_action_item_data: any;
	grouped_action_item_data_loaded: boolean = false;
	getGroupedActionItemData() {
		this.is_selected = false;
		this.selected_grouped_action_item_data = [];

		this.grouped_action_item_data_loaded = false;
		let route: any = "/groupedaction/?activity_type=" + this.show_grouped_action_item_meta_data.activity_type + "&segment=" + this.grouped_action_item_segement
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.grouped_action_item_data = res['data'];
				this.grouped_action_item_data_loaded = true;

			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	is_selected: boolean = false;
	selected_grouped_action_item_data: any = [];
	selectAll(event) {
		if (event.checked == true) {
			this.selected_grouped_action_item_data = JSON.parse(JSON.stringify(this.grouped_action_item_data['table']));
			this.is_selected = true;
		} else {
			this.selected_grouped_action_item_data = [];
			this.is_selected = false;
		}
	}

	checkIndividualSelection(data) {
		const index = this.selected_grouped_action_item_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			return true;
		} else {
			return false;
		}
	}

	selectIndividual(event, data) {
		const index = this.selected_grouped_action_item_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			if (event.checked == true) {
				this.selected_grouped_action_item_data.splice(index, 0, data);
			} else {
				this.selected_grouped_action_item_data.splice(index, 1);
			}
		} else {
			this.selected_grouped_action_item_data.splice(index, 0, data);
		}

		if (this.grouped_action_item_data['table'].length == this.selected_grouped_action_item_data.length) {
			this.is_selected = true;
		} else {
			this.is_selected = false;
		}
	}

	selection_error: boolean = false;
	save(action) {
		if (this.selected_grouped_action_item_data.length > 0) {
			this.selection_error = false;
			if (action == "email") {
				this.email_data = {
					subject: "",
					email_body: "",
					scheduled_date: "",
				};
				this.email_data_errors = {
					subject: false,
					email_body: false,
					scheduled_date: false,
				};
				this.show_email_input_section = true;
			} else {
				this.saveBulkAction(action);
			}
		} else {
			this.selection_error = true;
		}
	}

	editorConfig: any = {
		editable: true,
		  spellcheck: true,
		  height: 'auto',
		  minHeight: '0',
		  maxHeight: 'auto',
		  width: 'auto',
		  minWidth: '0',
		  translate: 'yes',
		  enableToolbar: true,
		  showToolbar: true,
		  placeholder: 'Enter text here...',
		  defaultParagraphSeparator: '',
		  defaultFontName: '',
		  defaultFontSize: '',
		  fonts: [
			{class: 'arial', name: 'Arial'},
			{class: 'times-new-roman', name: 'Times New Roman'},
			{class: 'calibri', name: 'Calibri'},
			{class: 'comic-sans-ms', name: 'Comic Sans MS'}
		  ],
		  customClasses: [
		  {
			name: 'quote',
			class: 'quote',
		  },
		  {
			name: 'redText',
			class: 'redText'
		  },
		  {
			name: 'titleText',
			class: 'titleText',
			tag: 'h1',
		  },
		],
		sanitize: true,
		toolbarPosition: 'top',
		toolbarHiddenButtons: [
		  // ['bold', 'italic'],
		  // ['fontSize']
		  ['insertImage', 'insertVideo',]
		]
	};
	email_data: any = {
		subject: "",
		email_body: "",
		scheduled_date: "",
	};
	email_data_errors: any = {
		subject: false,
		email_body: false,
		scheduled_date: false,
	};
	show_email_input_section: boolean = false;
	current_date: any = new Date();

	saveBulkAction(action) {
		let payload: any = {
			type: this.show_grouped_action_item_meta_data.activity_type,
			ids: [],
			action: action,
		};

		for (let index = 0; index < this.selected_grouped_action_item_data.length; index++) {
			payload.ids.push(this.selected_grouped_action_item_data[index].id)
		}

		if (action == "email") {
			payload.email_body = this.email_data.email_body;
			payload.subject = this.email_data.subject;
			payload.scheduled_date = moment(this.email_data.scheduled_date).format();
		}
		
		this.commonService.postData("/assigngroupaction/", payload).subscribe(
			(res: any) => {
				this.selected_grouped_action_item_data = [];
				this.is_selected = false;
				this.commonService.showToast('success', "Action applied successfully to the selected clients.");
				this.closeGroupedActivity();

			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	validateEmailBulkAction() {
		if (this.email_data.subject != "" && this.email_data.subject != null) {
			this.email_data_errors.subject = false;
		} else {
			this.email_data_errors.subject = true;
		}

		if (this.email_data.email_body != "" && this.email_data.email_body != null) {
			this.email_data_errors.email_body = false;
		} else {
			this.email_data_errors.email_body = true;
		}

		if (this.email_data.scheduled_date != "" && this.email_data.scheduled_date != null) {
			this.email_data_errors.scheduled_date = false;
		} else {
			this.email_data_errors.scheduled_date = true;
		}

		if (
			this.email_data_errors.subject == false &&
			this.email_data_errors.email_body == false &&
			this.email_data_errors.scheduled_date == false
		) {
			this.saveBulkAction("email");
		}

	}

}
